<template>
    <div class="modal fade" id="modalInvoiceLog" role="dialog">
      <div
        class="modal-dialog modal-dialog-centered modal-scroll"
        style="max-width: 1500px; margin-left: 15px"
      >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title black-text" style="font-weight: bold">
               Log Aktivitas
              </h4> 
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-sm table-bordered table-striped table-responsive-sm">
              <thead>
                <tr class="black-text" style="font-weight: bold">
                  <th style="width: 200px">Tanggal</th>
                  <th style="width: 100px">Aktivitas</th>
                  <th style="width: 180px">Oleh</th>
                  <th style="width: 220px">Detail</th>
                </tr>
              </thead>
              <tbody v-if="invoiceDetailLogData.length == 0 || !invoiceDetailLogData">
                <tr>
                  <td colspan="4" class="text-center">
                    No Data Available
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr v-for="item in invoiceDetailLogData" :key="item.id">
                  <td
                    style="text-align: center"
                  >
                    {{formatDate(item.createdAt,'DD MMMM YYYY, HH:mm' )}}
                  </td>
                  <!-- Aktivitas -->
                  <td
                    style="text-align: center"
                  >
                    {{item.name}}
                  </td>
                  <!-- Oleh -->
                  <td>
                    {{item.createdByName}}
                  </td>
                  <!-- Detil-->
                  <td >
                   <div v-for="(detail, index) in item.logText" :key="index">
                    <div v-for="(value, key) in detail" :key="key">
                      {{key}};
                      <div v-html="value.replace(/(?:\r\n|\r|\n)/g, '<br>')"></div>
                    </div>
                   </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'ModalInvoiceLog',
  props: ['invoiceId'],
  data () {
    return {
      invoiceDetailLogData : [],
    }
  },
  methods:{
    // processDetailString(data) {
    //   return data.replace('\\n','<br/>')
    // },
    formatDate(value, dateFormat) {
      return moment(value).format(dateFormat)
    },
    getInvoiceDetailLogData(){
      this.loadingTable = true

      this.$http.get(`${process.env.GET_INVOICE_DETAIL_LOG}/${this.invoiceId}/list`,
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        this.invoiceDetailLogData = response.data.data
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
  },
  created(){
    this.getInvoiceDetailLogData()
    this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .title-square-background {
    background-color: #F8F9FB;
  }

  .invoice-overview-indicator{
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .invoice-overview-value {
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    letter-spacing: -0.02px;
  }

  .most-overdue-title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-text {
    color: #2E3646;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-orange {
    color: #FF5252;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/ModalInvoiceLog.vue